import { useProxy } from "./use-proxy";

/**
 * login://foo/bar
 * -> /api/redirect/to=login...
 *
 * https://foo/bar (todo)
 * -> https://foo/bar
 */
export const useTargetUrl = (target, params) => {
  console.warn(
    "[DEPRECATED]",
    "`useTargetUrl` is deprecated and will be removed in the future version. Please switch to `useProxy`"
  );

  const { createTargetUrl } = useProxy();

  return {
    loading: false,
    error: null,
    url: createTargetUrl(target, params)
  };
};
